document.addEventListener('DOMContentLoaded', function() {
  var titleBlock = document.querySelector('.text-block--AdHNSd0Y5VVNVMjBtN__text_xrnftG');
  if (!titleBlock) return;

  var rating = document.createElement('a');
  rating.href = '#';
  rating.className = 'pdp-rating-link';
  rating.innerHTML = '<svg width="80" height="16" viewBox="0 0 100 16" xmlns="http://www.w3.org/2000/svg"><path fill="#f5a623" d="M10 1.3l2.4 4.8 5.3.8-3.8 3.7.9 5.3L10 13.4l-4.7 2.5.9-5.3L2.4 6.9l5.3-.8z"/><path fill="#f5a623" d="M30 1.3l2.4 4.8 5.3.8-3.8 3.7.9 5.3L30 13.4l-4.7 2.5.9-5.3-3.8-3.7 5.3-.8z"/><path fill="#f5a623" d="M50 1.3l2.4 4.8 5.3.8-3.8 3.7.9 5.3L50 13.4l-4.7 2.5.9-5.3-3.8-3.7 5.3-.8z"/><path fill="#f5a623" d="M70 1.3l2.4 4.8 5.3.8-3.8 3.7.9 5.3L70 13.4l-4.7 2.5.9-5.3-3.8-3.7 5.3-.8z"/><path fill="#f5a623" d="M90 1.3l2.4 4.8 5.3.8-3.8 3.7.9 5.3L90 13.4l-4.7 2.5.9-5.3-3.8-3.7 5.3-.8z"/></svg><span>4.8 (136 reviews)</span>';

  rating.addEventListener('click', function(e) {
    e.preventDefault();
    var target = document.querySelector('.rl-section');
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  });

  titleBlock.parentNode.insertBefore(rating, titleBlock);
});
